export function deriveVariant({ value, variationIndex, fallback = 'default' }) {
    if (typeof value === 'boolean') {
        return value ? 'variant_1' : 'control';
    }
    if (variationIndex === null || variationIndex === undefined) {
        return fallback;
    }
    return `variant_${variationIndex + 1}`;
}
export const featureFlagFilters = {
    /**
     * Include all feature flags (no filtering)
     */
    all: () => true,
    /**
     * Include only flags ending with "_experiment"
     */
    experimentOnly: (key) => key.endsWith('_experiment'),
    /**
     * Include only flags ending with "_v3"
     */
    v3Only: (key) => key.endsWith('_v3'),
    /**
     * Creates a filter that includes only the specified flag names
     * @param flagNames - Array of flag names to include
     * @returns Filter function that checks if a flag is in the list
     * @example
     * filter: featureFlagFilters.includeOnly(['my_flag', 'another_flag'])
     */
    includeOnly: (flagNames) => {
        const flagSet = new Set(flagNames);
        return (key) => flagSet.has(key);
    },
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidXRpbHMuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvbGliL2ZlYXR1cmUtZmxhZ3MvdXRpbHMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBaUJBLE1BQU0sVUFBVSxhQUFhLENBQUMsRUFBRSxLQUFLLEVBQUUsY0FBYyxFQUFFLFFBQVEsR0FBRyxTQUFTLEVBQXdCO0lBQ2pHLElBQUksT0FBTyxLQUFLLEtBQUssU0FBUyxFQUFFLENBQUM7UUFDL0IsT0FBTyxLQUFLLENBQUMsQ0FBQyxDQUFDLFdBQVcsQ0FBQyxDQUFDLENBQUMsU0FBUyxDQUFDO0lBQ3pDLENBQUM7SUFFRCxJQUFJLGNBQWMsS0FBSyxJQUFJLElBQUksY0FBYyxLQUFLLFNBQVMsRUFBRSxDQUFDO1FBQzVELE9BQU8sUUFBUSxDQUFDO0lBQ2xCLENBQUM7SUFFRCxPQUFPLFdBQVcsY0FBYyxHQUFHLENBQUMsRUFBRSxDQUFDO0FBQ3pDLENBQUM7QUFFRCxNQUFNLENBQUMsTUFBTSxrQkFBa0IsR0FBRztJQUNoQzs7T0FFRztJQUNILEdBQUcsRUFBRSxHQUFZLEVBQUUsQ0FBQyxJQUFJO0lBRXhCOztPQUVHO0lBQ0gsY0FBYyxFQUFFLENBQUMsR0FBVyxFQUFXLEVBQUUsQ0FBQyxHQUFHLENBQUMsUUFBUSxDQUFDLGFBQWEsQ0FBQztJQUVyRTs7T0FFRztJQUNILE1BQU0sRUFBRSxDQUFDLEdBQVcsRUFBVyxFQUFFLENBQUMsR0FBRyxDQUFDLFFBQVEsQ0FBQyxLQUFLLENBQUM7SUFFckQ7Ozs7OztPQU1HO0lBQ0gsV0FBVyxFQUFFLENBQUMsU0FBbUIsRUFBcUIsRUFBRTtRQUN0RCxNQUFNLE9BQU8sR0FBRyxJQUFJLEdBQUcsQ0FBQyxTQUFTLENBQUMsQ0FBQztRQUNuQyxPQUFPLENBQUMsR0FBVyxFQUFXLEVBQUUsQ0FBQyxPQUFPLENBQUMsR0FBRyxDQUFDLEdBQUcsQ0FBQyxDQUFDO0lBQ3BELENBQUM7Q0FDRixDQUFDIn0=